export default __webpack_public_path__ + "static/media/storagemask.33a528ea.png";